import MisCitasComponent from "../components/MisCitas/MisCitas";
export default function MisCitas() {
  return <MisCitasComponent />;
}
